import React from "react";
import { useEffect } from "react";
import { Grid, Box, Typography, Container, Stack } from "@mui/material";
import avatar from "../../../assets/img/my-grad.jpg";
import "./AboutMe.css";
import { Element } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";

import { LazyLoadImage } from "react-lazy-load-image-component";

export default function AboutMe() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Element name="myScrollToElement">
      <div>
        <Container>
          <Box
            container
            
            // spacing={}
            style={{
              display: "flex",
              flexDirection: "column",
              // backgroundColor: "blue",
              justifyContent: "center",
              alignItems: { xs: "center" },
            }}
            sx={{
              padding: { xs: "20px" },
              marginTop: { xs: "30px", md: "60px" },
              marginBottom: { lg: "140px" },
            }}
            // direction="column"
          >
            <Typography
              variant="h5"
              sx={{
                color: "#00adb5",
                fontWeight: 500,

                fontFamily: "Getboreg Trial Only",
                textAlign: "center",
              }}
            >
              A B O U T M E
            </Typography>

            <Grid
              container
              sx={{
                marginTop: { md: "80px", xs: "20px" },
              }}
              
            >
              <Grid style={{}} md={7}>
                <Stack
                  direction="row"
                  justifyContent="left"
                  alignItems="center"
                  gap="8px"
                  data-aos="fade-right"
                  data-duration="5000"
                  sx={{ marginTop: { md: "60px", xs: "20px" } }}
                >
                  <Typography
                    sx={{
                      color: "#00adb5",
                      fontWeight: 500,
                      fontFamily: "Getboreg Trial Only",
                      textAlign: "center",
                      fontSize: { md: "50px", xs: "25px" },
                    }}
                    variant="h3"
                  >
                    Overview
                  </Typography>
                  <Box
                    style={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "#00adb5",
                      borderRadius: "50%",
                    }}
                  ></Box>
                </Stack>
                <Box
                  marginTop="20px"
                  data-aos="fade-right"
                  // data-duration="5000"
                >
                  <Typography
                    color="white"
                    style={{
                      fontFamily: "Titillium Web",
                      fontWeight: "400",
                      letterSpacing: "1px",
                      maxWidth: "550px",
                    }}
                  >
                    I am a motivated Fullstack Developer with a strong
                    foundation in modern technologies, specializing in creating
                    high-performance web applications and delivering seamless
                    user experiences. With expertise in React.js (Next.js,
                    Gatsby.js) and Node.js, I develop robust and scalable
                    solutions across the stack.
                    <br></br>
                    <br></br>I have extensive experience in frontend
                    development, utilizing JavaScript, HTML, and CSS to craft
                    responsive and interactive interfaces. My backend skills
                    include building and maintaining APIs with Node.js and
                    integrating databases like MySQL and Firebase for
                    authentication and data management.<br></br>
                    <br></br>
                    In addition to my technical skills, I have worked with
                    various platforms and content management systems, including
                    Shopify, Webflow, WordPress, and Prismic. My commitment to
                    continuous learning drives me to explore new coding
                    languages and web technologies, ensuring that my skills
                    remain at the cutting edge of the industry. Whether working
                    on fullstack projects or focusing on frontend excellence, I
                    am dedicated to optimizing application performance and
                    delivering high-quality code that meets the needs of users
                    and stakeholders alike.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                style={{}}
                xs={5}
                sx={{ display: { xs: "none", md: "block" } }}
              >
                <Box
                  style={{
                    height: "500px",
                    width: "400px",
                    overflow: "hidden",
                    borderRadius: "6px",
                    marginTop: "110px",
                  }}
                  data-aos="fade-left"
                >
                  <LazyLoadImage
                    img
                    className="avatar"
                    src={avatar}
                    alt=""
                    effect="blur"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </Element>
  );
}
